import styled from "styled-components";

export const MobileContainer = styled.div`
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-self: center;
    padding-bottom: 16px;
`
export const ItemInfoContainer = styled.div`
    width: 80%;
    margin-left: 12px;
`
export const ViewEditContainer = styled.div`
    flex-direction: row;
    display: flex;
    width: 140px;
    margin-pottom: 12px;
    justify-content: space-between;
`

export const SwitchContainer = styled.div`
    margin-top: 10px;
    flex: 1;
`